import { createTheme } from '@mui/material/styles'

const media = createTheme({})

const theme: any = {
  //thats done for using breakpoints
  ...media,
  typography: {
    fontFamily: 'CircularRegular'
  },
  palette: {
    primary: {
      main: '#94004A',
      contrastText: '#ffffff'
    },
    secondary: {
      main: '#F41211',
      contrastText: '#ffffff'
    },
    warning: {
      main: '#F41211',
      contrastText: '#ffffff'
    },
    grey: {
      100: '#E5E5E5', // for lines
      200: '#F1F2F4', // for background
      300: '#80868E' // for text
    }
  },
  components: ({
    MuiIconButton: {
      styleOverrides: {
        root: {
          color: 'rgba(0, 0, 0, 0.87)',
          fontWeight: 400
        }
      }
    },
    MuiTypography: {
      styleOverrides: {
        h5: {
          fontFamily: 'CircularBold'
        },
        h4: {
          fontFamily: 'CircularBold'
        },
        h3: {
          fontFamily: 'CircularBold'
        },
        h2: {
          fontFamily: 'CircularBold'
        },
        h1: {
          fontFamily: 'CircularBold'
        }
      }
    },
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          color: 'rgba(0, 0, 0, 0.87)',
          fontWeight: 400
        }
      }
    },
    MuiTabs: {
      styleOverrides: {
        indicator: {
          display: 'none'
        },
        root: {
          minHeight: '40px',
          fontWeight: 400
        }
      }
    },
    MuiTab: {
      styleOverrides: {
        root: {
          minHeight: '40px',
          fontWeight: 400,
          [media.breakpoints.up('sm')]: {
            minWidth: 'auto'
          }
        },
        textColorInherit: {
          opacity: '1'
        }
      }
    },
    MuiChip: {
      styleOverrides: {
        colorPrimary: {
          backgroundColor: '#94004A'
        }
      }
    },
    MuiInputLabel: {
      styleOverrides: {
        outlined: {
          fontSize: '0.8rem',
          transform: 'translate(8px, 10px) scale(1)'
        }
      }
    },
    MuiTableCell: {
      styleOverrides: {
        head: {
          fontWeight: 400
        }
      }
    },
    MuiDialogActions: {
      styleOverrides: {
        root: {
          padding: '16px 0 0'
        }
      }
    },
    MuiButton: {
      styleOverrides: {
        root: {
          fontFamily: 'CircularBold',
          fontSize: '0.8125rem',
          textTransform: 'uppercase' as const,
          borderRadius: '6px',
          boxShadow: '0px 0.5px 4px rgba(0,0,0,0.15)',
          padding: '8px',
          '&:hover': {
            boxShadow: '0px 0.5px 4px rgba(0,0,0,0.15)'
          }
        },
        sizeSmall: {
          padding: '8px'
        },
        sizeMedium: {
          padding: '8px'
        },
        sizeLarge: {
          padding: '8px'
        },
        containedPrimary: {
          backgroundColor: '#94004A',
          color: '#ffffff',
          border: '1px solid #94004A',
          '&:hover': {
            backgroundColor: '#670033'
          },
          '&.Mui-disabled': {
            backgroundColor: '#94004A',
            color: '#fff'
          }
        },
        outlinedPrimary: {
          backgroundColor: '#ffffff',
          color: '#000000',
          border: '1px solid rgb(221, 221, 221)',
          boxShadow: '0px 1px 4px rgba(0,0,0,0.06)',
          '&:hover': {
            backgroundColor: '#f5f5f5',
            border: '1px solid rgb(221, 221, 221)',
            boxShadow: '0px 1px 4px rgba(0,0,0,0.06)'
          }
        },
        text: {
          boxShadow: 'none',
          '&:hover': { boxShadow: 'none' }
        }
      },
      variants: [
        {
          props: { variant: 'dashed' as any },
          style: {
            backgroundColor: '#ffffff',
            color: '#94004A',
            border: '1px dashed #94004A',
            padding: '12px',
            boxShadow: 'none',
            '&:hover': {
              backgroundColor: '#ffffff',
              border: '1px dashed #94004A',
              boxShadow: 'none'
            }
          }
        }
      ]
    },
    MuiDatePickerToolbar: {
      styleOverrides: {
        root: {
          backgroundColor: '#94004A',
          color: '#fff',
          padding: '16px 24px'
        },
        title: {
          color: '#fff',
          fontFamily: 'CircularBold',
          fontSize: '1.5rem',
          lineHeight: 1.2
        }
      }
    },
    MuiPickersToolbar: {
      styleOverrides: {
        root: {
          backgroundColor: '#94004A',
          color: '#fff',
          '& .MuiTypography-root': {
            color: '#fff'
          }
        },
        content: {
          color: '#fff'
        },
        penIconButton: {
          display: 'none'
        },
        penIconButtonLandscape: {
          display: 'none'
        }
      }
    },
    MuiPickersCalendarHeader: {
      styleOverrides: {
        root: {
          marginTop: 8,
          marginBottom: 4,
          paddingLeft: 16,
          paddingRight: 16
        },
        labelContainer: {
          flex: 1,
          justifyContent: 'center',
          marginRight: 0
        },
        label: {
          color: '#000',
          fontWeight: 600
        },
        switchViewButton: {
          color: '#000'
        }
      }
    },
    MuiPickersArrowSwitcher: {
      styleOverrides: {
        button: {
          color: '#000'
        }
      }
    },
    MuiPickersDay: {
      styleOverrides: {
        root: {
          width: 36,
          height: 36,
          fontSize: '0.875rem',
          '&.MuiPickersDay-today:not(.Mui-selected)': {
            border: 'none'
          },
          '&.Mui-selected': {
            backgroundColor: '#94004A',
            color: '#fff',
            '&:hover': {
              backgroundColor: '#670033'
            }
          }
        },
        dayWithMargin: {
          margin: '0 2px'
        },
        today: {
          border: '1px solid rgb(221, 221, 221)'
        }
      }
    }
    // MuiButtonBase: {
    //   root: {
    //     fontFamily: 'CircularRegular'
    //   }
    // },
    // MuiGrid: {
    //   root: {
    //     fontFamily: 'CircularRegular'
    //   }
    // }
  }) as any
}

export { theme }
